import React, { useState, useEffect } from 'react';

const Navigation: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/806aa2bb-32be-4f80-9adf-db7b1ca392b1.png" 
              alt="Antriva Logo" 
              className="h-10 w-10 object-contain"
            />
            <h1 className={`text-2xl font-bold transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              Antriva
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white/90'
              }`}
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white/90'
              }`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('approach')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white/90'
              }`}
            >
              Approach
            </button>
            <button 
              onClick={() => scrollToSection('case-studies')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white/90'
              }`}
            >
              Case Studies
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-teal-500 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 cursor-pointer ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white/95 backdrop-blur-md rounded-lg shadow-lg">
            <div className="flex flex-col space-y-4 px-4">
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 text-sm font-medium hover:text-teal-500 transition-colors text-left cursor-pointer"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 text-sm font-medium hover:text-teal-500 transition-colors text-left cursor-pointer"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('approach')}
                className="text-gray-700 text-sm font-medium hover:text-teal-500 transition-colors text-left cursor-pointer"
              >
                Approach
              </button>
              <button 
                onClick={() => scrollToSection('case-studies')}
                className="text-gray-700 text-sm font-medium hover:text-teal-500 transition-colors text-left cursor-pointer"
              >
                Case Studies
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-teal-500 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;